'use client';

import type { ButtonVariantProps } from '../types';
import ButtonComponent, { ButtonSizes, ButtonVariants } from '@pixum/button';
import Text, { TextTag, TEXT_VARIANT } from '@pixum/text';
import { useDeviceInfo } from 'hooks';
import { handleRedirectToSoftwareDownloadPageClick } from '../utils';
import { Icon } from '@pixum/icon';

/**
 * `Download Button` component displays a download button.
 *
 * @component
 * @param link - A Link Object.
 * @param constants - The list of constants needed.
 *
 */
export function ButtonWithPhotobookDownloadSoftware({ link, variant = ButtonVariants.STRONG, size = ButtonSizes.LARGE }: ButtonVariantProps) {
  const deviceInfo = useDeviceInfo();
  const operatingSystem = deviceInfo.operatingSystem;
  const url = link?.url || '';

  const handleClick = () => {
    handleRedirectToSoftwareDownloadPageClick(url, operatingSystem);
  };

  return (
    <ButtonComponent
      className="button--download button-for-desktop"
      label="download-software button"
      size={size}
      type="button"
      variant={variant}
      onClick={handleClick}
    >
      {variant === ButtonVariants.STRONG && <Icon name="download" color="white" />}
      <div className="button--download--text">
        <Text tag={TextTag.SPAN} variant={TEXT_VARIANT.BUTTON}>
          {link?.title}
        </Text>
      </div>
    </ButtonComponent>
  );
}
